export const units = {
  TB: 1099511627776,
  GB: 1073741824,
  MB: 1048576,
  kB: 1024,
  B: 1,
} as const
